<template>
	<div class="chat-cluster-container">
		<div class="chat-cluster-box">
			<div class="chat-cluster-coustom" :style="{'display': customDisplay}">
				<chat-custom @custom-call="customCall($event)" @chat-custom-call="chatCustomCall($event)" key="chat-cluster-home-cc"></chat-custom>
			</div>
			<div class="chat-cluster-list-box">
				<chat-cluster-list 
					@custom-filter="customFilterCall($event)" 
					@cluster-click="clusterClickCall($event)" 
					@create-cluster-call="createClusterCall"
					@cluster-delete-call="clusterDeleteCall($event)"
					:currentCustom="custom">
				</chat-cluster-list>
			</div>
		</div>
		<div class="chat-cluster-info">
			<chat-cluster-info v-if="currentCluster.id !== undefined" 
				:cluster="currentCluster"
				@add-member-call="addMemberCall($event)"
				@reduce-member-call="reduceMemberCall($event)">
			</chat-cluster-info>
			<chat-empty showText="请选择一个群" v-else></chat-empty>
		</div>
		<chat-cluster-member
			:customId="customId"
			:fanList="fanList" 
			:filterFanList="filterFanList" 
			:comTitle="comTitle" 
			:optType="optType"
			:customList="customList"
			@close-option="closeOption()"
			@fans-select-call="fansSelectCall($event)"
			v-if="openOpt">
		</chat-cluster-member>
	</div>
</template>

<script>
	import ChatCustom from '../../../components/ChatCustom.vue'
	import ChatClusterList from './ChatClusterList.vue'
	import ChatClusterInfo from './ChatClusterInfo.vue'
	import ChatEmpty from '../../../components/ChatEmpty.vue'
	import ChatClusterMember from './ChatClusterMember.vue'
	import {pushAddMemberFromRoom,pushDelMemberFromRoom,pushCreateChatRoom} from '../../../socket/socketEventSender.js'
	import {webSaveClusterMemberTemp} from '../../../network/web/cluster-member-temp.js'
	import {getFansListByCustomIdAndWxids} from '../../../network/local/friend.js'
	import {webCreateCluster} from '../../../network/web/cluster.js'

	export default {
		name: "ChatClusterHome",
		data(){
			return {
				customDisplay: 'none',
				currentCluster:{},
				// 客服筛选值
				custom:{
					id: 0,
					open_id: ''
				},
				customList:[],
				openOpt: false,
				// 下面5个参数，传递给粉丝选择页面
				optType:'',
				fanList:[],
				filterFanList:[],
				comTitle:'',
				customId:0
			}
		},
		components:{
			ChatCustom,
			ChatClusterList,
			ChatClusterInfo,
			ChatEmpty,
			ChatClusterMember
		},
		methods:{		
			init(){
				this.optType = ''
				this.fanList = []
				this.filterFanList = []
				this.comTitle = ''
				this.customId = 0
			},
			// 客服过滤点击回调
			customFilterCall(val){
				val ? this.customDisplay = 'block' :  this.customDisplay = 'none'
			},
			
			// 群列表点击回调
			clusterClickCall(val){
				this.currentCluster = val
			},
			
			// 客服点击回调
			customCall(data){
				this.custom = data
			},
			
			// 客服列表-所有客服数据回调
			chatCustomCall(data){
				this.customList = data
			},
			
			// 子页面关闭回调
			closeOption(){
				this.openOpt = false
			},
			
			// 群列表页面点击添加拉群按钮回调
			createClusterCall(){
				this.init()
				this.comTitle = '创建新群'
				this.optType = 'create'
				this.openOpt = true
			},
			
			// 详情页面-添加群成员点击回调
			addMemberCall(data){
				this.init()
				this.comTitle = '添加群成员'
				this.optType = 'add'
				if(data.filterMembers !== undefined){
					this.filterFanList = data.filterMembers
				}
				if(data.customId !== undefined){
					this.customId = data.customId
				}
				this.openOpt = true
			},
			
			// 详情页面-删除群成员点击回调
			reduceMemberCall(data){
				this.init()
				this.comTitle = '删除群成员'
				this.optType = 'reduce'
				if(data.fanList !== undefined){
					this.fanList = data.fanList
				}
				if(data.customId !== undefined){
					this.customId = data.customId
				}
				this.openOpt = true
			},
			
			// 粉丝页面选择页-确定后的数据回调
			fansSelectCall(data){
				this.openOpt = false
				if(data.list.length === 0){
					CHAT_LAYER.msg('未选择任何粉丝',{icon:2})
					return
				}
				switch(data.type){
					case 'create':
						this.createCluster(data)
						break
					case 'add':
						this.optClusterMember(data)
						break
					case 'reduce':
						this.optClusterMember(data)
						break
				}
				return
				
			},
			
			// 新建群
			createCluster(data){
				if(data.list.length > 38){
					CHAT_LAYER.msg('新群人少最大39人，请修改...',{icon:2})
					return
				}
				if(data.list.length < 2){
					CHAT_LAYER.msg('新群人少最少2人，请修改...',{icon:2})
					return
				}
				getFansListByCustomIdAndWxids(data.customId,data.list,l_res=>{
					let fans = []
					for (let i = 0; i < l_res.length; i++) {
						fans.push(l_res[i].id)
					}
					let i_data = {
						customId: data.customId,
						fansIds: JSON.stringify(fans)
					}
					webCreateCluster(i_data,res=>{
						if(res && res.cluster_id !== undefined){
							CHAT_LAYER.msg('建群指令推送成功，请稍后...',{icon:7})
							pushCreateChatRoom(res.cluster_id)
						}
					})
				})
			},
			
			// 添加成员或删除成员
			optClusterMember(data){
				let msg = ""
				let order = ''
				let memberOptType = 0
				if(data.type === 'add'){
					msg = '添加成员指令推送成功，请稍后刷新页面查看'
					order = 'C_AddMemberFromRoom'
					memberOptType = 1
				}else if(data.type === 'reduce'){
					msg = '删除成员指令推送成功，请稍后刷新页面查看'
					order = 'C_DelMemberFromRoom'
					memberOptType = 2
				}
				getFansListByCustomIdAndWxids(this.customId,data.list,l_res=>{
					let fans = []
					for (let i = 0; i < l_res.length; i++) {
						fans.push({
							friends_id:l_res[i].id,
							friends_open_id:l_res[i].open_id,
							friends_wx_name:l_res[i].wx_name,
							friends_photo:l_res[i].wx_photo,
						})
					}
					let requestData = {
						fans: fans,
						mwxids:data.list
					}
					webSaveClusterMemberTemp(this.currentCluster.id,JSON.stringify(requestData),memberOptType,res=>{
						CHAT_LAYER.msg(msg,{icon:7})
						if(memberOptType == 1){
							pushAddMemberFromRoom(this.currentCluster.id,this.customId)
						}else if(memberOptType == 2){
							pushDelMemberFromRoom(this.currentCluster.id)
						}
					})
				})
			},
			
			// 删除群
			clusterDeleteCall(id){
				this.currentCluster = {}
			}
		}
	}
</script>

<style>
	.chat-cluster-container{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		overflow: hidden;
	}
	.chat-cluster-container .chat-cluster-box{
		width: 400px;
		height: 100%;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: nowrap;
		background-color: #efefef;
	}
	.chat-cluster-box .chat-cluster-coustom{
		width: 80px;
		height: 100%;
		overflow: hidden;
	}
	.chat-cluster-box .chat-cluster-list-box{
		width: 0;
		flex-grow: 1;
		height: 100%;
		overflow: hidden;
	}
	.chat-cluster-container .chat-cluster-info{
		position: absolute;
		top: 0;
		left: 400px;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}
</style>
